import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/** Toasts sharing a `toastId` show once, e.g. when many loads fail at once. */
export const notifyError = (
  message: string,
  options?: { toastId?: string },
) => {
  toast.error(message, {
    toastId: options?.toastId,
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const LOAD_ERROR_MESSAGE =
  "Could not load some data. Check your connection and try again.";

/** A failed load; shows once however many fail together. */
export const notifyLoadError = () =>
  notifyError(LOAD_ERROR_MESSAGE, { toastId: "load-error" });

export const notifySuccess = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const notifyInfo = (message: string) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const ToastBlock = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={6000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      theme="light"
      style={{
        zIndex: "var(--z-toast)",
      }}
    />
  );
};
